import React, { useState } from 'react';
import imagen1 from './assets/Med_No-01.jpg'
import { useNavigate } from 'react-router-dom';
import './Recuperacion.css'
import '@fontsource/fira-sans';
import '@fontsource/fira-sans/700.css';
import '@fontsource/fira-sans/500.css';
import '@fontsource/fira-sans/400-italic.css';
import '@fontsource/fira-sans/200.css';
import Recuperacion01Img from "./assets/Recuperacion.jpg";

function Recuperacion() {
    const navigate = useNavigate();
    const handleAnterior = () => {
        navigate('/indicaciones/dia-cirugia');
        window.scrollTo(0, 0);
      };
    return (
      
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1 className="titlePreguntas_recu">Después de tu cirugía</h1>
            <br></br>
            <div className="container_recu"> 
                <div id="card_1_recu"> 
                    
                    
                     
                    <p className="p_1_recu"> Permanecerás por lo menos <b> una hora </b> en el área de recuperación posterior a tu procedimiento, haznos saber si tienes algún tipo de disconfort, <b> dolor, náuseas o algún otro síntoma </b>, el equipo de enfermería y anestesia estaremos al pendiente, si transcurrida una hora todo se encuentra en orden, regresarás a tu habitación o al área de cirugía ambulatoria, según sea el caso.
 

                    </p>
              
                </div>
                <img className='imeva_recu' src={Recuperacion01Img} id="image_1" alt="Imagen Recuperacion" />
            
            </div>

            <br></br>
            <br></br>


        {/* BOTONES */}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '30px' }}>
          <button className="nav-button-recu" onClick={handleAnterior}>Anterior</button>
          
        </div>

        </div>);

}

export default Recuperacion;
